import dayjs from 'dayjs';

export function formatDisplayDate(dateStr) {
  if (!dateStr) return '';
  const date = dayjs(dateStr);
  if (!date.isValid()) return '';

  return date.format('MMM DD, YYYY'); // Example: Jun 12 2025
}
